import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box } from '@mui/material';
import Skeleton from 'app/shared/components/common/Skeleton';
import PropTypes from 'prop-types';

import { LoadStatus } from 'constants/aiProcessRuns';
import { SKELETON_TYPES } from 'constants/skeleton';

import { loadStepMessagesAction } from 'store/aiProcessRuns';

import { AiActivityTestIds } from '../../../AiActivity.testIds';
import AiActivityEmptyState from '../../../AiActivityEmptyState';

import {
  MESSAGES_ERROR_SUBTITLE,
  MESSAGES_ERROR_TITLE,
  MESSAGES_RETRY_LABEL,
  MESSAGES_SKELETON_ROW_COUNT,
  MESSAGES_SKELETON_ROW_HEIGHT,
} from './StepMessagesPlaceholder.constants';

const StepMessagesPlaceholder = ({ stepExecutionId, status }) => {
  const dispatch = useDispatch();

  const onRetry = useCallback(() => {
    dispatch(loadStepMessagesAction({ stepExecutionId, force: true }));
  }, [dispatch, stepExecutionId]);

  if (status === LoadStatus.ERROR) {
    return (
      <AiActivityEmptyState
        actionLabel={MESSAGES_RETRY_LABEL}
        dataTestId={AiActivityTestIds.STEP_MESSAGES_ERROR_STATE}
        subtitle={MESSAGES_ERROR_SUBTITLE}
        title={MESSAGES_ERROR_TITLE}
        onAction={onRetry}
      />
    );
  }

  return (
    <Box data-testid={AiActivityTestIds.STEP_MESSAGES_SKELETON}>
      <Skeleton
        height={MESSAGES_SKELETON_ROW_HEIGHT}
        length={MESSAGES_SKELETON_ROW_COUNT}
        type={SKELETON_TYPES.LIST}
      />
    </Box>
  );
};

StepMessagesPlaceholder.propTypes = {
  stepExecutionId: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};

export default memo(StepMessagesPlaceholder);
